// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-application--wrap{min-height:unset!important}.title_1{margin:10px auto 0 auto;-webkit-user-select:none;-moz-user-select:none;user-select:none;font-size:1.25em;font-weight:500}", ""]);
// Exports
module.exports = exports;
